import { z } from 'zod'

import { http } from '@/shared/api'

export type AdminInvoice = {
  id: string
  /** Идентификатор счёта в платёжном модуле — с ним платёж ищут на той стороне. */
  providerInvoiceId: string
  amountCents: number
  network: string
  symbol: string
  decimals: number
  payAddress: string
  /** Наименьшие единицы токена строкой: 18 знаков BSC не переживают JSON-число. */
  payAmountUnits: string
  status: string
  createdAt: string
  userId: string
  userUsername: string
}

const itemSchema = z.object({
  id: z.string(),
  provider_invoice_id: z.string().optional(),
  amount_cents: z.number(),
  network: z.string(),
  symbol: z.string(),
  decimals: z.number(),
  pay_address: z.string(),
  pay_amount_units: z.string(),
  status: z.string(),
  created_at: z.string(),
  user_id: z.string(),
  user_username: z.string(),
})

const listSchema = z.object({ items: z.array(itemSchema).nullable() })

export async function fetchAdminInvoices(signal?: AbortSignal): Promise<AdminInvoice[]> {
  const { items } = await http.get('admin/invoices', { schema: listSchema, signal })
  return (items ?? []).map((raw) => ({
    id: raw.id,
    providerInvoiceId: raw.provider_invoice_id ?? '',
    amountCents: raw.amount_cents,
    network: raw.network,
    symbol: raw.symbol,
    decimals: raw.decimals,
    payAddress: raw.pay_address,
    payAmountUnits: raw.pay_amount_units,
    status: raw.status,
    createdAt: raw.created_at,
    userId: raw.user_id,
    userUsername: raw.user_username,
  }))
}
